import styled from 'styled-components';
import React from 'react';
import { UpdateWorkspace } from '../../../../shared/types/workspaceTypes';
import { FlexRow } from '../../../../shared/FlexRow';
import { Body, Headline } from '../../../../shared/styled-components/styled_text';

interface Props {
  data: UpdateWorkspace;
}

export const OnboardingStep2Preview: React.FC<Props> = ({ data }) => {
  return (
    <Container>
      <FlexRow
        width={'100%'}
        justify={'space-between'}
        align={'flex-start'}
        style={{ padding: '0 1.2rem 1.6rem', borderBottom: '1px solid var(--border-color)' }}
      >
        <Headline size={'m'}>미리보기</Headline>
        <FlexRow width={'fit-content'} justify={'flex-start'} align={'center'} gap={'0.4rem'}>
          <img src={'/images/common/warning_circle_outline.svg'} alt={'warning icon'} />
          <Body size={'m'} style={{ color: ' var(--content-color-secondary)' }}>
            채용 사이트는 구독 요금제 사용자만 이용할 수 있어요.
          </Body>
        </FlexRow>
      </FlexRow>
      <ContentWrapper />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  min-width: 86.2rem;
  min-height: 87.5rem;
  padding: 2.4rem 3.2rem;
  border-radius: 24px;
  background: var(--background-2);

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2.4rem;
`;

const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-width: 79.8rem;
  min-height: 75rem;

  background-image: url('/images/workspace-wizard/application_link_preview.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;
